import UserPersistence from "@/persistence/UserPersistence";
export const moduleId = 'red-pay';

export const state = {
    orgId: UserPersistence.getOrgId(),
    isShow: true,
    payDetails: '',
    payId: '',
    abId: '',
    accountInfo: {},
    routerUrl: '',
    isView: false,
    disable: false,
    buttonType: '',
    billCode: ''
}
export const mutations = {
    setRedPayDetails(state, data) {
        state.payDetails = data
    },
    setRedPayIsShow(state, flag) {
        state.isShow = flag
    },
    setOrgId(state, id) {
        state.orgId = id
    },
    setRedPayId(state, data) {
        state.payId = data.id
        state.abId = data.abId
    },
    setAccountInfo(state, data) {
        state.accountInfo = data
    },
    setRedPayRouterUrl(state, url) {
        state.routerUrl = url
    },
    setRedPayIsView(state, flag) {
        state.isView = flag
    },
    setRedPayDisable(state, flag) {
        state.disable = flag
    },
    setButtonType(state, type) {
        state.buttonType = type
    },
    setBillCode(state, code) {
        state.billCode = code
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/billing-center/red-pay/index.js